'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Basic Colors
 */
var colors = exports.colors = {
  // Black & White
  black: '#151000',
  white: '#FFF',

  /*
   * Major colors
   */
  cream: '#fffdd8',

  // Gray
  grayDark: '#323232',
  gray: '#777',
  grayLittle: '#AAA',
  grayLight: '#CCC',
  grayVeryLight: '#e7e7e7',
  grayLighter: '#f5f5f5',

  // Blue
  blue: '#234b78',
  blueDark: '#1b3b5e',
  blueLight: '#bad1eb',

  // Sky
  sky: '#40cafd',
  skyDark: '#3bb3de',
  skyLight: '#cdf2ff',

  // Green
  green: '#5e9d07',
  greenLight: '#ebf3e1',
  greenDark: '#538a06',

  // Green Water
  greenWater: '#0ac3a7',
  greenWaterDark: '#078975',
  greenWaterLight: '#e6f9f6',

  // Red
  red: '#d83a37',
  redDark: '#c13530',
  redLight: '#fbebeb',

  // Yellow
  yellow: '#ffb400',
  yellowDark: '#e3a000',
  yellowLight: '#fff8ee',
  brown: '#6d6246',
  orange: '#f38000',

  /*
   * Minor colors
   */
  plum: '#79485d',
  plumLight: '#e1cdd6',
  purple: '#633687',
  purpleLight: '#914caf'
};

/*
 * Colors RGB
 */
var colorsRGB = exports.colorsRGB = {
  // Black & White
  black: '21, 16, 0',
  white: '255, 255, 255',

  /*
   * Major colors
   */
  cream: '255, 253, 216',

  // Gray
  grayDark: '50, 50, 50',
  gray: '119, 119, 119',
  grayLittle: '170, 170, 170',
  grayLight: '204, 204, 204',
  grayVeryLight: '231, 231, 231',
  grayLighter: '245, 245, 245',

  // Blue
  blue: '35, 75, 120',
  blueDark: '27, 59, 94',
  blueLight: '186, 209, 235',

  // Sky
  sky: '64, 202, 253',
  skyDark: '59, 179, 222',
  skyLight: '205, 242, 255',

  // Green
  green: '94, 157, 7',
  greenLight: '235, 243, 225',
  greenDark: '83, 138, 6',

  // Green Water
  greenWater: '10, 195, 167',
  greenWaterDark: '7, 137, 117',
  greenWaterLight: '230, 249, 246',

  // Red
  red: '216, 58, 55',
  redDark: '193, 53, 48',
  redLight: '251, 235, 235',

  // Yellow
  yellow: '255, 180, 0',
  yellowDark: '227, 160, 0',
  yellowLight: '255, 248, 238',
  brown: '109, 98, 70',
  orange: '243, 128, 0',

  /*
   * Minor colors
   */
  plum: '121, 72, 93',
  plumLight: '225, 205, 214',
  purple: '99, 54, 135',
  purpleLight: '145, 76, 175'
};